import Esculpidas from '../Image/ManosPies/esculpidas.png'
import Kapping from '../Image/ManosPies/kapping.png'
import Semi from '../Image/ManosPies/semi.png'
import SoftGel from '../Image/ManosPies/softGel.png'
import Tradicional from '../Image/ManosPies/tradicional.png'



const DataManosPies = [
    {
        img: Esculpidas,
        title: "Esculpidas",
        description: "Como la palabra lo indica, lo que se hace es “esculpir” una uña artificial sobre la uña natural, fijándola con luz ultravioleta. Luego se puede esmaltar sobre dicha uña con esmalte común o semipermanente y aplicar diferentes tipos de diseños y/o decoraciones.",
        duracion: "120 min"
    },
    {
        img: Kapping,
        title: "Kapping",
        description: "Consiste en aplicar una fina capa de acrílico o gel fortificador sobre la uña que actuará como una barrera protectora. A diferencia de las uñas esculpidas, este baño en gel kapping no alarga la uña natural sino que acompaña el crecimiento de la misma y dura hasta 20 días.",
        duracion: "60 min"

    },
    {
        img: Semi,
        title: "Semipermanentes",
        description: "Es un esmaltado de secado inmediato y de larga duración que mantiene un resultado reluciente. Este efecto se consigue con la aplicación de esmaltes específicos y el secado de las uñas en una luz UV o LED.",
        duracion: "40 min"
    },
    {
        img: SoftGel,
        title: "Soft gel",
        description: "Consiste en un tipo de uñas postizas hechas de gel suave que se pegan con un esmalte de gel que actúa como pegamento. Al ser un formato pre-creado, permite que la clienta elija entre multitud de tamaños, limados y largos.",
        duracion: "40 min"

    },
    {
        img: Tradicional,
        title: "Tradicional",
        description: "Permite que las uñas permanezcan pintadas, pero requiere cuidados especiales. Utilizando productos de calidad y siempre anteponiendo una base para proteger la uña natural y al mismo tiempo para que el producto adhiera mejor y dure más.",
        duracion: "40 min"
    }

]

export default DataManosPies;